// @flow
import { disciplinesByName } from 'constants/disciplines';
export const getDisciplineName = (disciplineId: number) =>
  disciplineId && disciplinesByName[disciplineId]
    ? disciplinesByName[disciplineId]
    : '';
